import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const pricingPlans = [
  {
    title: "🛒 Retail Module Pricing Plans",
    subtitle:
      "Perfect for individual sellers, small retailers, and agri/non-agri businesses",
    price: "Flexible Usage Plan – Pay As You Grow ₹2,000/year",
    features: [
      "2% of total turnover (order value)",
      "Upto 100 products",
      "Unlimited customer orders",
      "Ideal for early-stage or low-volume sellers",
    ],
  },
  {
    title: "🛒 Retail Module Pricing Plans",
    subtitle: "Best for growing businesses with high order volumes",
    price: "Flat Annual Plan – Unlimited Growth, Fixed Price ₹20,000/year",
    features: [
      "Unique QR Code & Digital Link",
      "Custom Logo & Business Branding on Profile",
      "Digital Product Catalog Setup",
      "1 High-Quality Marketing Poster (with logo & QR)",
    ],
  },
  {
    title: "🌾 Agri Input Marketing Module",
    subtitle:
      "Ideal for retailers, distributors & companies offering seeds, fertilizers, pesticides, tools, machinery, etc.",
    price: "₹5,000 + GST/year – Platform Access",
    features: [
      "₹100 + GST (₹118)/product/year – Product Listing Fee",
      "1 Image Included",
      "Extra Images: ₹20/image (one-time upload cost)",
      "Unique QR Code & Digital Link per product",
      "1 Custom Image Poster with branding & QR",
    ],
  },
  {
    title: "📢 Crop/Product Marketing Module",
    subtitle:
      "For farmers, FPOs, and farmer groups to promote their produce directly",
    price: "₹100 + GST (₹118) per crop/product/year",
    features: [
      "1 Image Included",
      "Extra Images: ₹20/image",
      "Pricing for Individual Farmer",
      "Pricing for Individual Farmer Farmer Groups (Up to 500 Farmers)",
      "₹2,500 + GST/year – Includes up to 10 crops/products",
      "Additional product (above 10): ₹100 + GST (₹118)/product/year",
    ],
  },
  {
    title: "🌱 ICS Pricing Plan",
    subtitle:
      "Organic Farming Documentation via Simple IT Tools (Ideal for Organic Certification Support: PGS, NPOP, NOP, GAP, etc.)",
    price: "₹10,000 + GST/year Per ICS",
    features: [
      "Average farm size per farmer is up to 5 acres",
      "Per Farmer Charges ₹40 + GST/year",
      "One-Time Setup Charge: ₹1,000 + GST per ICS",
      "Chargeable Customization/Custom Template",
    ],
  },
];

const PricingSection = () => {
  const settings = {
    infinite: true,
    speed: 1800, // Slide animation duration (in ms)
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0, // Time between slides
    pauseOnHover: true,
    cssEase: "ease-in-out",
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 1 },
      },
    ],
  };

  return (
    <section id="pricing" className="py-24 bg-gray-50">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Pricing
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Affordable digital solutions for farmers, rural entrepreneurs, and
            grassroots innovations.
          </p>
        </div>

        {/* Slider */}
        <Slider {...settings}>
          {pricingPlans.map((plan, idx) => (
            <div key={idx} className="px-4 h-full">
              <div className="h-full flex">
                <div className="group bg-white rounded-2xl border border-gray-200 hover:border-blue-500 transition-all duration-300 shadow-sm flex flex-col justify-between w-full p-8">
                  <div className="flex-1 flex flex-col justify-between">
                    <div>
                      <h3 className="text-xl font-bold text-gray-900 mb-2">
                        {plan.title}
                      </h3>
                      <p className="text-gray-600 mb-4">{plan.subtitle}</p>
                      <div className="text-2xl font-semibold text-gray-900 mb-6">
                        {plan.price}
                      </div>
                      <ul className="space-y-4">
                        {plan.features.map((feature, i) => (
                          <li key={i} className="flex items-start">
                            <svg
                              className="h-5 w-5 text-blue-600 mt-0.5"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M5 13l4 4L19 7"
                              />
                            </svg>
                            <span className="ml-3 text-gray-700">
                              {feature}
                            </span>
                          </li>
                        ))}
                      </ul>
                    </div>
                    <a
                      href="#contact"
                      className="mt-8 block w-full text-center font-medium transition-all duration-300 rounded-md px-4 py-3 bg-blue-600 text-white hover:bg-blue-700"
                    >
                      Get Started
                    </a>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default PricingSection;
